import request from "@/utils/request";

export function palmClassificationGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/PalmClassification/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function palmClassificationGet(params) {
    return request({
        url: "/api/services/app/PalmClassification/Get",
        method: "GET",
        params
    });
}

export function palmClassificationCreate(data) {
    return request({
        url: "/api/services/app/PalmClassification/Create",
        method: "POST",
        data
    });
}

export function palmClassificationUpdate(data) {
    return request({
        url: "/api/services/app/PalmClassification/Update",
        method: "PUT",
        data
    });
}

export function palmClassificationDelete(params) {
    return request({
        url: "/api/services/app/PalmClassification/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/palm_classification.js